import Intercom from '@intercom/messenger-js-sdk';
function RootIntercom(params) {
    const crypto = require('crypto');
    const hash = crypto.createHmac('sha256', params.intercomSecret).update(params.userEmail).digest('hex');
    Intercom({
        app_id: params.intercomAppId,
        name: params.userName,
        email: params.userEmail,
        created_at: params.userCreatedAt,
        user_hash: hash
    });
    return null;
}
export default RootIntercom;
